<template>
  <Popover
    class="pg-layout-message"
    popper-class="pg-layout-message__popper"
    width="310"
    @show="onShow"
  >
    <template #reference>
      <Badge :value="total.all" :max="99" :hidden="total.all === 0">
        <i class="ivu-icon-icon-pg-announcement pg-layout-message__icon"></i>
      </Badge>
    </template>
    <div class="pg-layout-message__popper-title">
      <span
        class="pg-layout-message__popper-title-text"
        :class="{
          'pg-layout-message__popper-title-text--active': parameters.method === 'EVENT_METHOD_10',
        }"
        @click="swichTab('EVENT_METHOD_10')"
      >
        <Badge
          :value="total.message"
          :max="99"
          :hidden="total.message === 0"
          class="pg-layout-message__popper-title-count"
          >消息中心</Badge
        >
      </span>
      <!-- <span
        class="pg-layout-message__popper-title-text"
        :class="{
          'pg-layout-message__popper-title-text--active': parameters.method === 'EVENT_METHOD_20',
        }"
        @click="swichTab('EVENT_METHOD_20')"
      >
        <Badge
          :value="total.deal"
          :max="99"
          :hidden="total.deal === 0"
          class="pg-layout-message__popper-title-count"
          >待办</Badge
        >
      </span> -->
    </div>
    <ul
      class="pg-layout-message__popper-content"
      v-infinite-scroll="onLoad"
      :infinite-scroll-immediate="false"
      :infinite-scroll-distance="5"
      :infinite-scroll-disabled="loading || noMore"
    >
      <li v-for="item in unreadNews" :key="item.id" @click="toBriefMessage(item)">
        <span
          class="pg-layout-message__popper-content-type"
          :class="{ 'pg-layout-message__popper-content-item--unread': !item.read }"
          >[{{ item.method.name }}]</span
        >
        <span class="pg-layout-message__popper-content-text">{{ item.content }}</span>
        <span class="pg-layout-message__popper-content-date">{{ item.begin }}</span>
      </li>
      <li class="pg-layout-message__popper-content-loading" v-show="loading">加载中...</li>
      <li class="pg-layout-message__popper-content-loading" v-show="noMore">没有更多了</li>
    </ul>
    <div class="pg-layout-message__popper-footer">
      <Link
        :underline="false"
        type="warning"
        class="pg-layout-message__popper-footer-btn"
        @click="allRead"
      >
        <i class="ivu-icon-ywc"></i>
        全部标记为已读
      </Link>
      <Link
        :underline="false"
        type="warning"
        class="pg-layout-message__popper-footer-btn"
        @click="toPassportMessage"
      >
        查看全部
      </Link>
    </div>
  </Popover>
</template>
<script setup>
import { ref, reactive, getCurrentInstance, watch } from 'vue'
import { Popover, Link } from 'element-ui'
import Badge from './badge.vue'
import { pgNotification } from '../../notification/index'
import { post, get } from '../../../utils/index'
import { useRouterSystem } from '../../../hooks/index'
import { useRouter } from 'vue-router/composables'

const { proxy } = getCurrentInstance()
const { toOtherSystem, toSystemOrOrerDetail } = useRouterSystem()

const toBriefMessage = async (unreadNew) => {
  if (unreadNew.action && unreadNew.action !== '.') {
    toSystemOrOrerDetail(proxy.$store.state.user.currentToken.id, unreadNew)
  }
  if (!unreadNew.read) {
    const [resData] = await get(
      'rest/ezcomp/message/read',
      { id: unreadNew.id },
      { errorTip: null }
    )
    if (resData) {
      unreadNew.read = true
    }
  }
}
//消息推送
let begin = 0
const total = reactive({
  all: 0,
  deal: 0,
  message: 0,
})
const getPollMessage = async () => {
  const [resData] = await get('rest/ezcomp/message/nextMessage', { begin }, { errorTip: null })
  total.all = resData?.total?.all ?? 0
  total.deal = resData?.total?.deal ?? 0
  total.message = resData?.total?.message ?? 0
  begin = resData?.timestamp ?? 0
  const messageData = resData?.data ?? []
  for (let item of messageData) {
    pgNotification({
      type: item.method && item.method.code == 'EVENT_METHOD_20' ? 'warning' : 'info',
      tag: item.method.name,
      title: item.title,
      content: item.content,
      buttonText: item.action != '.' ? item.action : false,
      onClick: () => {
        toBriefMessage(item)
      },
    })
  }
}

let timer = null
const delayed = async () => {
  await getPollMessage()
  timer = setTimeout(() => {
    delayed()
  }, 10000)
}
watch(
  () => proxy.$store.state.user.currentToken,
  () => {
    if (timer) {
      clearTimeout(timer)
    }
    begin = 0
    delayed()
  },
  { immediate: true }
)

//消息列表
const unreadNews = ref([])
const param = {
  pageNo: 1,
  pageSize: 15,
}

//EVENT_METHOD_10 -> 消息
//EVENT_METHOD_20 -> 待办
const parameters = ref({
  method: 'EVENT_METHOD_10',
})
const loading = ref(false)
const noMore = ref(false)
const onLoad = async (addPage = 1) => {
  param.pageNo += addPage
  loading.value = true
  const [resData] = await post(
    'rest/ezcomp/message/queryPaged',
    Object.assign({}, param) //{ parameters: parameters.value }
  )
  loading.value = false
  unreadNews.value.push(...(resData?.data ?? []))
  if (unreadNews.value.length === resData.totalCount) {
    noMore.value = true
  }
}
const onShow = () => {
  param.pageNo = 1
  unreadNews.value = []
  onLoad(0)
}
const swichTab = (tab) => {
  if (parameters.value.method !== tab) {
    parameters.value.method = tab
    noMore.value = false
    onShow()
  }
}
const allRead = async () => {
  const [resData] = await get(
    'rest/ezcomp/message/readAll',
    {}, //method: parameters.value.method
    { successTip: 'message' }
  )
  if (resData) {
    getPollMessage()
    onShow()
  }
}

const router = useRouter()
const toPassportMessage = () => {
  if (proxy.$store.state.user.CurrentTicket?.system?.code === 'PASSPORT') {
    router.push({
      name: parameters.value.method === 'EVENT_METHOD_20' ? 'standby_home' : 'messageEnter_home',
    })
  } else {
    const params = {
      tokenId: proxy.$store.state.user.currentToken.id,
      organizationCode: '',
      systemCode: 'PASSPORT',
    }
    toOtherSystem(
      params,
      `${proxy.GLOBAL.domain}/passport/index.html`,
      `#/${
        parameters.value.method === 'EVENT_METHOD_20'
          ? 'standby/standby_home'
          : 'messageEnter/messageEnter_home'
      }`
    )
  }
}
</script>
<style lang="scss">
@import '../style/layout-message.scss';
</style>
